import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { ProductInventoryPalletsTab } from "@/screens/Inventory/subfeatures/ProductInventory/components"
import { productInventoryPalletsSearchSchema } from "@/screens/Inventory/subfeatures/ProductInventory/schemas"

export const Route = createFileRoute("/app/inventory/products/$productId/_layout/pallets")({
  validateSearch: zodValidator(productInventoryPalletsSearchSchema),
  component: () => <ProductInventoryPalletsTab />,
})
